// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_SPACING = 10;
export const HTML_FONT_SIZE = 16;
export const TOOLBAR_HEIGHT_MOBILE = 64;
export const TOOLBAR_HEIGHT_DESKTOP = 100;
export const HEADER_HEIGHT_MOBILE = 120;
export const HEADER_HEIGHT_DESKTOP = 220;
